<template>
  <div id="website">
    <div class="logo">
      <img :src="logoImg" alt="" />
    </div>
    <nav-menu @click="handleClick"></nav-menu>
    <popup :visiable="visiable" @close="closeDrawer"></popup>
    <video id="myvideo" width="100%" height="auto" muted="muted" autoplay loop>
      <source src="../../assets/video/background.mp4" type="video/mp4" />
    </video>
    <div class="frame-container">
      <div class="fame-wrapper">
        <h1>名人堂</h1>
        <h5>名人堂为各领域受益的运动员来自INDIBA技术的顶尖选手而设立。</h5>
        <!-- <img src="../../assets/img/logo-en.png" alt="Hall Of Fame" /> -->
      </div>
    </div>
    <div class="btn-wrapper">
      <div class="btn-container">
        <div class="btn btn-actived">全部</div>
        <div class="btn">田径</div>
        <div class="btn">篮球</div>
        <div class="btn">自行车</div>
        <div class="btn">足球</div>
        <div class="btn">手球</div>
        <div class="btn">赛车</div>
        <div class="btn">游泳</div>
        <div class="btn">网球</div>
      </div>
    </div>
    <div class="person-wrapper">
      <div class="person-container">
        <div class="personal">
          <img src="../../assets/img/character/bg1.jpg" />
          <div class="personal-des">
            <i>足球</i>
            <p class="personal-name">费兰·托雷斯</p>
            <p class="read-more">
              <a
                href="https://mp.weixin.qq.com/s/3ugooGzf4TWVhgKQk_SUEA"
                target="_blank"
                >获取更多 ></a
              >
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg2.jpg" />
          <div class="personal-des">
            <i>足球</i>
            <p class="personal-name">安德雷斯·伊涅斯塔</p>
            <p class="read-more">
              <a
                href="https://mp.weixin.qq.com/s/xHgEZRd2j1lNKznZufBQYQ"
                target="_blank"
                >获取更多 ></a
              >
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg3.jpg" />
          <div class="personal-des">
            <i>网球</i>
            <p class="personal-name">拉菲尔·纳达尔</p>
            <p class="read-more">
              <a
                href="https://mp.weixin.qq.com/s/6neNdSez8PRIHGKuf3XOnQ"
                target="_blank"
                >获取更多 ></a
              >
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg4.jpg" />
          <div class="personal-des">
            <i>篮球</i>
            <p class="personal-name">西班牙篮球联合会</p>
            <p class="read-more">
              <a href="javascript:;">获取更多 ></a>
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg5.jpg" />
          <div class="personal-des">
            <i>田径</i>
            <p class="personal-name">法国田径运动联合会</p>
            <p class="read-more">
              <a href="javascript:;">获取更多 ></a>
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg6.jpg" />
          <div class="personal-des">
            <i>篮球</i>
            <p class="personal-name">帕纳辛纳斯科队</p>
            <p class="read-more">
              <a
                href="https://mp.weixin.qq.com/s/jl463H1NPuy1KH6zu7ka2w"
                target="_blank"
                >获取更多 ></a
              >
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg7.jpg" />
          <div class="personal-des">
            <i>铁人三项</i>
            <p class="personal-name">哈维·戈麦斯·诺亚</p>
            <p class="read-more">
              <a href="javascript:;">获取更多 ></a>
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg8.jpg" />
          <div class="personal-des">
            <i>自行车</i>
            <p class="personal-name">阿斯塔纳自行车队</p>
            <p class="read-more">
              <a href="javascript:;">获取更多 ></a>
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg9.jpg" />
          <div class="personal-des">
            <i>网球</i>
            <p class="personal-name">加尔比妮·穆古拉扎</p>
            <p class="read-more">
              <a
                href="https://mp.weixin.qq.com/s/e7hNh2iA41ujOGleycXeHw"
                target="_blank"
                >获取更多 ></a
              >
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg10.jpg" />
          <div class="personal-des">
            <i>自行车</i>
            <p class="personal-name">西班牙移动之星自行车队</p>
            <p class="read-more">
              <a href="javascript:;">获取更多 ></a>
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg11.jpg" />
          <div class="personal-des">
            <i>田径</i>
            <p class="personal-name">跑步俱乐部</p>
            <p class="read-more">
              <a
                href="https://mp.weixin.qq.com/s/VW1xc4IBU-IV0xHSH_2TwQ"
                target="_blank"
                >获取更多 ></a
              >
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg12.jpg" />
          <div class="personal-des">
            <i>摩托车</i>
            <p class="personal-name">亚历克斯·埃斯帕加罗</p>
            <p class="read-more">
              <a
                href="https://mp.weixin.qq.com/s/kiiZepbAXBHgiDN8bXVJwQ"
                target="_blank"
                >获取更多 ></a
              >
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg13.jpg" />
          <div class="personal-des">
            <i>手球</i>
            <p class="personal-name">法国国家手球队</p>
            <p class="read-more">
              <a href="javascript:;">获取更多 ></a>
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg14.jpg" />
          <div class="personal-des">
            <i>自行车</i>
            <p class="personal-name">奈洛·金塔纳</p>
            <p class="read-more">
              <a href="javascript:;">获取更多 ></a>
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg15.jpg" />
          <div class="personal-des">
            <i>田径</i>
            <p class="personal-name">克里斯托夫·勒迈特雷</p>
            <p class="read-more">
              <a href="javascript:;">获取更多 ></a>
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg16.jpg" />
          <div class="personal-des">
            <i>摩托车</i>
            <p class="personal-name">亚历克斯·林斯</p>
            <p class="read-more">
              <a href="javascript:;">获取更多 ></a>
            </p>
          </div>
        </div>
        <div class="personal">
          <img src="../../assets/img/character/bg17.jpg" />
          <div class="personal-des">
            <i>游泳</i>
            <p class="personal-name">杰茜卡·瓦尔</p>
            <p class="read-more">
              <a href="javascript:;">获取更多 ></a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavMenu from "./components/NavMenu.vue";
import Popup from "./components/Popup.vue";
export default {
  name: "Found",
  data() {
    return {
      visiable: false,
      logoImg: require("../../assets/home/logo.png"),
    };
  },
  components: {
    Popup,
    NavMenu,
  },
  created() {
    document.title = "名人堂";
  },
  methods: {
    handleClick() {
      this.visiable = true;
    },
    closeDrawer() {
      this.visiable = false;
    },
  },
};
</script>

<style lang="less" scoped>
body,
#website {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  color: #fff;
  background-color: #001a70;
  @font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  user-select: none;
  box-sizing: border-box;
  .logo {
    width: 200px;
    height: 34px;
    left: 1.5rem;
    top: 1.8rem;
    z-index: 1;
    position: absolute;
  }
  #myvideo {
  }
  .frame-container {
    background-color: #fff;
    .fame-wrapper {
      width: 90%;
      padding: 2rem 0;
      margin: 0 auto;
      position: relative;
      h1 {
        font-size: 32px;
        font-weight: 700;
        margin-bottom: 0;
      }
      h5 {
        font-size: 20px;
        color: #666;
        font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS",
          sans-serif;
      }
      // img {
      //   position: absolute;
      //   top: 0;
      //   right: 0;
      // }
    }
  }
  .btn-wrapper {
    background-color: #e7e9ea;
    .btn-container {
      width: 90%;
      margin: 0 auto;
      padding: 2rem 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .btn {
        min-width: 6rem;
        font-weight: 700;
        margin: 10px;
        background-color: #fff;
        border-color: #fff;
        padding: 0.5rem 1rem;
        text-transform: uppercase;
        border-radius: 5px;
        cursor: pointer;
        color: #005670;
        text-align: center;
        &:hover {
          color: #222;
          background-color: #fcfcfc;
        }
      }
      .btn-actived {
        background-color: #52cec6;
        color: #fff;
      }
    }
  }
  .person-wrapper {
    background-color: #fff;
    // margin-top: 50px;
    padding-top: 2rem;
    .person-container {
      width: 90%;
      margin: 0 auto;
      display: grid;
      flex-wrap: wrap;
      grid-template-columns: 48% 48%;
      //   grid-column-gap: 10px;
      justify-content: space-between;
      //   align-items: center;
      .personal {
        width: 100%;
        cursor: pointer;
        position: relative;
        border-radius: 10px;
        margin: 10px 0;
        height: 280px;
        // background-color: #52cec6;
        // background-image: url(../../assets/img/character/bg1.jpg);
        // background-position: center;
        // background-size: cover;
        overflow: hidden;
        // filter: grayscale(100%);
        transition: all 0.5s;
        img {
          width: 100%;
        }
      }
      .personal:hover {
        // filter: grayscale(0%);
      }
      .personal:hover .personal-des {
        transform: translateY(0px);
      }
      .personal-des {
        background-image: linear-gradient(
          rgba(0, 0, 0, 0.01),
          rgba(0, 0, 0, 0.6)
        );
        padding: 0 20px;
        color: #ccc;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        transform: translateY(40px);
        transition: all 0.5s;
        .personal-name {
          font-size: 24px;
          font-weight: 600;
          margin-top: 10px;
          margin-bottom: 20px;
          color: #fff;
          line-height: 28px;
        }
        .read-more {
          font-size: 18px;
          color: #00bfb3;
          a {
            color: #00bfb3;
          }
        }
      }
    }
  }
}
</style>
